import createIcon from '@/lib/create-icon'

const HurlingIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      d='M12.0023 30.0425L13.9796 31.1459L16.4694 32.5834M32.1192 12.0444L14.5688 35.0777C13.7683 36.1283 13.2528 37.3679 13.0723 38.6763L12.4584 43.125L4.79175 38.3334L8.1502 36.0438C9.37568 35.2084 10.3325 34.0354 10.9047 32.667L21.9776 6.18911C23.3504 2.90636 27.2938 1.5752 30.3753 3.35432C33.4569 5.13344 34.2757 9.21411 32.1192 12.0444ZM41.8753 37.375C41.8753 40.5507 39.301 43.125 36.1253 43.125C32.9497 43.125 30.3753 40.5507 30.3753 37.375C30.3753 34.1994 32.9497 31.625 36.1253 31.625C39.301 31.625 41.8753 34.1994 41.8753 37.375Z'
      stroke='url(#paint0_linear_5314_425)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M12.0023 30.0425L13.9796 31.1459L16.4694 32.5834M32.1192 12.0444L14.5688 35.0777C13.7683 36.1283 13.2528 37.3679 13.0723 38.6763L12.4584 43.125L4.79175 38.3334L8.1502 36.0438C9.37568 35.2084 10.3325 34.0354 10.9047 32.667L21.9776 6.18911C23.3504 2.90636 27.2938 1.5752 30.3753 3.35432C33.4569 5.13344 34.2757 9.21411 32.1192 12.0444ZM41.8753 37.375C41.8753 40.5507 39.301 43.125 36.1253 43.125C32.9497 43.125 30.3753 40.5507 30.3753 37.375C30.3753 34.1994 32.9497 31.625 36.1253 31.625C39.301 31.625 41.8753 34.1994 41.8753 37.375Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M12.0023 30.0425L13.9796 31.1459L16.4694 32.5834M32.1192 12.0444L14.5688 35.0777C13.7683 36.1283 13.2528 37.3679 13.0723 38.6763L12.4584 43.125L4.79175 38.3334L8.1502 36.0438C9.37568 35.2084 10.3325 34.0354 10.9047 32.667L21.9776 6.18911C23.3504 2.90636 27.2938 1.5752 30.3753 3.35432C33.4569 5.13344 34.2757 9.21411 32.1192 12.0444ZM41.8753 37.375C41.8753 40.5507 39.301 43.125 36.1253 43.125C32.9497 43.125 30.3753 40.5507 30.3753 37.375C30.3753 34.1994 32.9497 31.625 36.1253 31.625C39.301 31.625 41.8753 34.1994 41.8753 37.375Z'
      stroke='url(#paint1_radial_5314_425)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5314_425'
        x1='4.79175'
        y1='2.56152'
        x2='49.5768'
        y2='30.9942'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5314_425'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23.3335 43.125) scale(18.5418 20.6564)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'HurlingIcon'
)

export default HurlingIcon
